import { Box, Button, CircularProgress } from '@mui/material'
import { EarnestMoneyDialog } from '../../dialogs/EarnestMoneyDialog'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useEarnestMoneyFlow } from '../../../../logic/useEarnestMoneyFlow'
import { DownloadUploadsComponent } from '../../../DownloadUploadsComponent'
import { useContent } from '../../../../logic'
import { toTitleCase } from '../../../../utils'
import { Alert } from '@mui/material'

export function EarnestMoneyTask({ orderKey, notificationId }: {
  orderKey: string, notificationId: string,
}) {
  const { search } = useLocation()

  const [showEarnestMoneyDialog, setShowEarnestMoneyDialog] = useState(false)

  const earnestMoneyDialogClicked = async () => {
    setShowEarnestMoneyDialog(true)
  }

  const { TaskText } = useContent()

  const {
    initiatePaymentMutation,
    cachedInitiatePaymentData,
    isPaymentSubmitted,
    isPaymentAcknowledged,
    isPaymentCompleted,
  } = useEarnestMoneyFlow(orderKey, notificationId, search)

  const initiatePaymentData = cachedInitiatePaymentData || initiatePaymentMutation?.data

  const showDownloadUploadsButton = isPaymentSubmitted || isPaymentAcknowledged || isPaymentCompleted

  return (
    <>
      {isPaymentCompleted ? (
        <></>  // Handled by PortalTaskComponent.  Fix later.
      ) : isPaymentAcknowledged || isPaymentSubmitted ? (
        <Box sx={{ textAlign: 'left', alignItems: 'flex-start', width: '100%' }}>
          <Alert severity="success" sx={{ mb: 3 }}>
            Your earnest money payment has been initiated, and your receipt is available below. Once the title company approves and processes your payment, the funds will be debited from your account.
          </Alert>
        </Box>
      ) : !isPaymentSubmitted && !initiatePaymentMutation?.error ? (
        <Button
          variant="contained"
          color="primary"
          onClick={earnestMoneyDialogClicked}
          startIcon={!initiatePaymentData ? <CircularProgress size={20} /> : null}
          disabled={!initiatePaymentData}
        >
          {!initiatePaymentData ? 'Loading...' : 'Complete Earnest Money'}
        </Button>
      ) : initiatePaymentMutation?.error ? (
        <Box sx={{ textAlign: 'left', alignItems: 'flex-start', width: '100%' }}>
          <Alert severity="error" sx={{ mb: 3 }}>
            {initiatePaymentMutation.error.message}
          </Alert>
        </Box>
      ) : null}
      {
        showDownloadUploadsButton &&
        <DownloadUploadsComponent
          button={
            <Button
              variant="contained"
              sx={{
                borderRadius: "40px",
                minWidth: "250px",
                color: "white",
              }}
            >
              {`Download ${toTitleCase(TaskText)} Documents`}
            </Button>
          }
        />
      }
      {
        showEarnestMoneyDialog &&
        initiatePaymentData &&
        <EarnestMoneyDialog
          regCode={initiatePaymentData.Registration}
          interactionPrefix={initiatePaymentData.InitiateEMDResponse.interactionPrefix}
          interactionSuffix={initiatePaymentData.InitiateEMDResponse.interactionSuffix}
          onClosed={() => { setShowEarnestMoneyDialog(false) }}
        />
      }
    </>
  )
}